<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <office-form />
  </v-container>
</template>

<script>
import OfficeForm from './_Form'
export default {
  name: 'AdminNotificationEdit',
  components: {
    OfficeForm
  },
  data () {
    return {
      breadcrumbs:[
        { text: 'お知らせ一覧', disabled: false, to: '/admin/notifications', exact: true },
        { text: 'お知らせ編集', disabled: true, to: '' },
      ]
    }
  },
  created() {},
  methods: {

  }
}
</script>

<style scoped>

</style>
